//部分用户使用的是有效期一年的虚假uuid
export function showUuid(uuid) {
  if (!uuid) {
    return '';
  }
  if (new Date().setFullYear(2024, 1, 22) < new Date().getTime()) {
    return uuid;
  } else {
    let newUuid = uuid;
    switch (uuid.toString()) {
      case '184579':
        newUuid = '1';
        break;
      case '3911191':
        newUuid = '6';
        break;
      case '3478779':
        newUuid = '77';
        break;
      case '3018952':
        newUuid = '69';
        break;
      case '701218':
        newUuid = '888';
        break;
      case '344682':
        newUuid = '999';
        break;
      default:
        newUuid = uuid;
        break;
    }
    return newUuid;
  }
}
